import config from '@app/config';

// Documents ride only the regular supplier-validation submission: the server's with-documents
// endpoint rejects every other form type (its 24h submission cap counts regular rows), so the
// incoming-payment-security page never offers, asks about, or sends them. Email verification is
// gated on the feature flag alone and stays on in both modes.
export function isDocumentUploadEnabled(isIpsMode: boolean): boolean {
  return !!config.featureFlags?.supplierRegistrationDocuments && !isIpsMode;
}
